import { render, staticRenderFns } from "./ContactHeader.vue?vue&type=template&id=2a2237d8&"
import script from "./ContactHeader.vue?vue&type=script&lang=js&"
export * from "./ContactHeader.vue?vue&type=script&lang=js&"
import style0 from "./ContactHeader.vue?vue&type=style&index=0&lang=stylus&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports